import ClientLike from "../client-like";

/**
 * 見積書印刷PDF取得用のAPI
 */
export default class PrintApi {
  constructor(private client: ClientLike) {}

  public async getEstimatePrint(
    id: Number,
    accessToken: string,
    printsExcludeTax: boolean
  ): Promise<string> {
    const res = await this.client.get("create_estimate_pdf.php", {
      id,
      accessToken,
      printsExcludeTax
    });
    return res.pdf;
  }

  public async getInvoicePrint(
    id: Number,
    accessToken: string,
    printsExcludeTax: boolean
  ): Promise<string> {
    const res = await this.client.get("create_invoice_pdf.php", {
      id,
      accessToken,
      printsExcludeTax
    });
    return res.pdf;
  }

  public async getInvoiceAllPrint(
    id: Number[],
    accessToken: string,
    printsExcludeTax: boolean,
    projectId?: string,
    companyId?: string
  ): Promise<string> {
    // console.log(id);
    const res = await this.client.get("create_invoice_all_pdf.php", {
      id,
      accessToken,
      printsExcludeTax,
      projectId,
      companyId
    });
    return res.pdf;
  }

  public async getPurchasePrint(
    id: Number,
    accessToken: string,
    printsExcludeTax: boolean
  ): Promise<string> {
    const res = await this.client.get("create_purchase_pdf.php", {
      id,
      accessToken,
      printsExcludeTax
    });
    return res.pdf;
  }

  public async getPurchaseAllPrint(
    id: Number[],
    accessToken: string,
    printsExcludeTax: boolean,
    projectId?: string,
    companyId?: string
  ): Promise<string> {
    // console.log(id);
    const res = await this.client.get("create_purchase_all_pdf.php", {
      id,
      accessToken,
      printsExcludeTax,
      projectId,
      companyId
    });
    return res.pdf;
  }

  /**
   * @deprecated 廃止したページでしか使ってない
   */
  public async getExpensesPrint(
    id: Number,
    accessToken: string,
    printsExcludeTax: boolean
  ): Promise<string> {
    const res = await this.client.get("create_expenses_pdf.php", {
      id,
      accessToken,
      printsExcludeTax
    });
    return res.pdf;
  }
}
